import APP from '../../../main.js'
import AppRecord from './AppRecord.js'

class RiskAssessment extends AppRecord {
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)
  }
  get entity_name(){
    return (this.entity||{name: this.entity_id}).name
  }
  get person(){
    return this.constructor.employeeStore.peopleById.get(this.person_id)
  }
  get person_name(){
    return (this.person||{name: this.person_id}).name
  }
}

export default RiskAssessment
